export const sign_bg = require("../assets/sign_bg.jpg");
